import http from "./http";

export default {
  show(id) {
    return http.plainAxiosInstance.get(`/matches/${id}`);
  },

  // GET /matches/upcoming — as próximas partidas, já ordenadas pela API (data,
  // depois hora, partida sem horário no fim do dia) e sem as passadas,
  // encerradas ou sem data. Leitura pública: funciona para anônimo.
  //
  // `limit` e `edition_modality_id` são opcionais; parâmetro vazio não é
  // mandado para não sujar o cache de URL.
  upcoming({ limit, edition_modality_id } = {}) {
    const params = {};
    if (limit) params.limit = limit;
    if (edition_modality_id) params.edition_modality_id = edition_modality_id;
    return http.plainAxiosInstance.get(`/matches/upcoming`, { params });
  },

  delete(id) {
    return http.plainAxiosInstance.delete(`/matches/${id}`);
  }
};
